(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1741],{

/***/ 80793:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StopStats"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StopStats"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longestNonStop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopCauseStats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopCauseId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopCauseName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopCauseDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopCategoryName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accTarget"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfStops"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMicroStop"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":229}}');
    doc.loc.source = JSON.parse('{"body":"fragment StopStats on StopStats {\\n  longestNonStop\\n  stopCauseStats {\\n    stopCauseId\\n    stopCauseName\\n    stopCauseDescription\\n    stopCategoryName\\n    type\\n    accDuration\\n    accTarget\\n    numberOfStops\\n    isMicroStop\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 75805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ Instance; },
/* harmony export */   "k": function() { return /* binding */ Graph; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_NoSsr__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51285);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88231);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(highcharts__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86781);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var highcharts_highcharts_more__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71222);
/* harmony import */ var highcharts_highcharts_more__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(highcharts_highcharts_more__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var highcharts_modules_drilldown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94438);
/* harmony import */ var highcharts_modules_drilldown__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(highcharts_modules_drilldown__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var highcharts_modules_exporting__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63125);
/* harmony import */ var highcharts_modules_exporting__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(highcharts_modules_exporting__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85466);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62690);
/* harmony import */ var _components_loading_overlay_spinner__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59967);
/* harmony import */ var _hocs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81861);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5887);




















if (typeof (highcharts__WEBPACK_IMPORTED_MODULE_1___default()) === "object") {
    highcharts_highcharts_more__WEBPACK_IMPORTED_MODULE_3___default()((highcharts__WEBPACK_IMPORTED_MODULE_1___default()));
    highcharts_modules_exporting__WEBPACK_IMPORTED_MODULE_5___default()((highcharts__WEBPACK_IMPORTED_MODULE_1___default()));
    highcharts_modules_drilldown__WEBPACK_IMPORTED_MODULE_4___default()((highcharts__WEBPACK_IMPORTED_MODULE_1___default()));
}
var styles = function(theme) {
    return {
        hideOverflow: {
            overflow: "hidden"
        },
        container: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            position: "relative"
        }, theme.breakpoints.down("sm"), {
            // Widen out the chart on small screens, so we can better see the data.
            marginLeft: theme.spacing(-3),
            marginRight: theme.spacing(-1.5)
        })
    };
};
var shouldUpdate = function(prevProps, nextProps, _prevState, _nextState) {
    var aggressivelyMinimizeRendering = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (prevProps.loading !== nextProps.loading) {
        return true;
    }
    if (prevProps.error !== nextProps.error) {
        return true;
    }
    // We do a comparison of the supplied compareForUpdate object, to see
    // if anything has changed.
    if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default()(prevProps === null || prevProps === void 0 ? void 0 : prevProps.compareForUpdate, nextProps === null || nextProps === void 0 ? void 0 : nextProps.compareForUpdate)) {
        return true;
    }
    if (aggressivelyMinimizeRendering) {
        return false;
    }
    return true;
};
var transferUpdatingPropsToState = function(props) {
    return {
        compareForUpdate: props.compareForUpdate,
        loading: props.loading,
        error: props.error
    };
};
// FIXME: This is used to help redraw the chart on printing. This may not be
// necessary at all with a rewrite, if so apply it using hooks to easily clean up
// on on dismount.
var mediaQueryList =  true && window.matchMedia && window.matchMedia("print");
var HighchartsGraph = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(HighchartsGraph, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(HighchartsGraph);
    function HighchartsGraph(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(this, HighchartsGraph);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            config: {},
            updatingProps: {}
        };
        _this.chartRef = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createRef();
        _this.printListener = function() {
            var ref;
            return (ref = _this.getChart()) === null || ref === void 0 ? void 0 : ref.reflow();
        };
        _this.setChartLoadingOrError = function(loading, error) {
            var chart = _this.getChart();
            if (chart) {
                if (error && !_this.props.hideChart) {
                    var _errorMsg;
                    chart.showLoading((_errorMsg = _this.props.errorMsg) !== null && _errorMsg !== void 0 ? _errorMsg : _this.props.t([
                        "shared:errorOcurredTryReloading"
                    ], {
                        defaultValue: "An error occurred! Please try reloading the page."
                    }));
                } else if (loading && !_this.props.hideChart) {
                    chart.showLoading(_this.props.t([
                        "shared:loadingFromServer"
                    ], {
                        defaultValue: "Loading data from server..."
                    }));
                } else {
                    chart.hideLoading();
                }
            }
        };
        _this.getChart = function() {
            var ref, ref1;
            if (typeof _this.props.chartRef === "function") {
                return;
            }
            return (ref1 = (ref = _this.props.chartRef || _this.chartRef) === null || ref === void 0 ? void 0 : ref.current) === null || ref1 === void 0 ? void 0 : ref1.chart;
        };
        var isRTL = [
            "he"
        ].some(function(lang) {
            return _this.props.i18n.language === lang;
        });
        var rtlOptions = {
            tooltip: {
                style: {
                    direction: "rtl",
                    textAlign: "right"
                },
                useHTML: true
            },
            xAxis: {
                labels: {
                    style: {
                        direction: "rtl",
                        textAlign: "center"
                    },
                    useHTML: true
                },
                title: {
                    style: {
                        direction: "rtl",
                        textAlign: "center"
                    },
                    useHTML: true
                }
            },
            yAxis: {
                title: {
                    style: {
                        direction: "rtl",
                        textAlign: "center"
                    },
                    useHTML: true
                }
            },
            legend: {
                rtl: true,
                style: {
                    direction: "rtl",
                    textAlign: "right"
                },
                useHTML: true
            }
        };
        highcharts__WEBPACK_IMPORTED_MODULE_1___default().setOptions((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
            chart: {
                style: {
                    fontFamily: _this.props.theme.typography.fontFamily
                }
            },
            lang: {
                months: _this.props.utils.getMonthArray(new Date(2020, 1, 1)).map(function(month) {
                    return _this.props.utils.format(month, "month");
                }),
                weekdays: _this.props.utils.formatWeekdays("EEEE"),
                shortMonths: _this.props.utils.getMonthArray(new Date(2020, 1, 1)).map(function(month) {
                    return _this.props.utils.format(month, "monthShort");
                })
            },
            global: {
                useUTC: false
            }
        }, isRTL ? rtlOptions : {}, _this.props.options || {}));
        _this.state.updatingProps = transferUpdatingPropsToState(props);
        return _this;
    }
    var _proto = HighchartsGraph.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (mediaQueryList && "removeEventListener" in mediaQueryList) {
            mediaQueryList.removeEventListener("change", this.printListener);
        }
        this.setState({
            updatingProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, transferUpdatingPropsToState(this.props)), {
                compareForUpdate: ""
            })
        });
    };
    _proto.componentDidMount = function componentDidMount() {
        if (mediaQueryList && "addEventListener" in mediaQueryList) {
            mediaQueryList.addEventListener("change", this.printListener);
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(_, __) {
        this.setChartLoadingOrError(this.props.loading, this.props.error);
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return shouldUpdate(this.props, nextProps, this.state, nextState, nextProps.aggressivelyMinimizeRendering);
    };
    _proto.render = function render() {
        var ref;
        var _props = this.props, classes = _props.classes, loading = _props.loading, error = _props.error, _configFn = _props.configFn, configFn = _configFn === void 0 ? Function.prototype : _configFn, configOptions = _props.configOptions, chartRef = _props.chartRef, hideChart = _props.hideChart;
        var config = this.state.config;
        if (hideChart) {
            return null;
        }
        // Highcharts for some reason does not use the responsive properties
        // on the initial render, so set the height manually, so the chart does not jump around.
        // A fix for https://github.com/BlackbirdHQ/meta/issues/1607
        var noOfVisibleLegends = Object.values(configFn(configOptions).series).reduce(function(sum, serie) {
            var ref;
            return serie.showInLegend || ((ref = serie.dataLabels) === null || ref === void 0 ? void 0 : ref.enabled) ? sum + 1 : sum;
        }, 0);
        var legendsHeight = noOfVisibleLegends * 16;
        var smallScreen = (180 + legendsHeight).toString();
        var ref1;
        var largeScreen = (ref1 = configOptions === null || configOptions === void 0 ? void 0 : configOptions.height) !== null && ref1 !== void 0 ? ref1 : smallScreen;
        var smallScreenCutoff = 536;
        var chartHeight = window.innerWidth < smallScreenCutoff ? smallScreen : largeScreen;
        var defaultConfig = {
            title: false,
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            chart: {
                height: chartHeight
            }
        };
        var ref2, ref3;
        var highchartsConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, defaultConfig, configFn(configOptions)), {
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: smallScreenCutoff
                        },
                        chartOptions: {
                            chart: {
                                height: smallScreen
                            }
                        }
                    }, 
                ]
            },
            plotOptions: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (ref2 = config === null || config === void 0 ? void 0 : config.plotOptions) !== null && ref2 !== void 0 ? ref2 : {}), {
                series: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (ref3 = config === null || config === void 0 ? void 0 : (ref = config.plotOptions) === null || ref === void 0 ? void 0 : ref.series) !== null && ref3 !== void 0 ? ref3 : {}), {
                    turboThreshold: 0
                })
            })
        });
        highchartsConfig.chart.height = chartHeight;
        if (loading || error) {
            highchartsConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, highchartsConfig), {
                plotOptions: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, highchartsConfig.plotOptions), {
                    series: {
                        animation: false
                    }
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_NoSsr__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loading_overlay_spinner__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                size: 35
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default()), {
                immutable: true,
                options: highchartsConfig,
                highcharts: (highcharts__WEBPACK_IMPORTED_MODULE_1___default()),
                ref: chartRef || this.chartRef,
                domProps: {
                    className: classes.hideOverflow
                },
                callback: this.props.onChartCreated
            })
        });
    };
    /**
   * `getDerivedStateFromProps` is mainly used to calculate if we need to rerun the configuration
   * generation function, `configFn`, or if we can save some processing and skip it.
   */ HighchartsGraph.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var shouldDerive = shouldUpdate(prevState.updatingProps, nextProps, prevState, undefined, nextProps.aggressivelyMinimizeRendering);
        if (shouldDerive && nextProps.configOptions && nextProps.configFn) {
            var ref, ref1;
            // This ensures we only run the `configFn` once, either after updatingProps are both updated
            // or in the case that they don't exist.
            if (nextProps.compareForUpdate !== undefined && ((ref = prevState.updatingProps) === null || ref === void 0 ? void 0 : ref.compareForUpdate) !== undefined || !nextProps.compareForUpdate === undefined && !((ref1 = prevState.updatingProps) === null || ref1 === void 0 ? void 0 : ref1.compareForUpdate) === undefined) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prevState), {
                    config: nextProps.configFn(nextProps.configOptions),
                    updatingProps: transferUpdatingPropsToState(nextProps)
                });
            }
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prevState), {
            updatingProps: transferUpdatingPropsToState(nextProps)
        });
    };
    return HighchartsGraph;
}(react__WEBPACK_IMPORTED_MODULE_7__.Component);
var Instance = (highcharts__WEBPACK_IMPORTED_MODULE_1___default());
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_8__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_17__/* .withTranslation */ .Z)([
    "shared"
]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__/* .withStyles */ .D)(styles, {
    withTheme: true
}), _hocs__WEBPACK_IMPORTED_MODULE_19__/* .withUtils */ .W);
var Graph = enhance(HighchartsGraph);


/***/ }),

/***/ 59967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57077);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5887);








var styles = function(_theme) {
    return {
        overlay: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, .3)"
        },
        center: {
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)"
        }
    };
};
var LoadingSpinnerOverlay = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(LoadingSpinnerOverlay, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(LoadingSpinnerOverlay);
    function LoadingSpinnerOverlay() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, LoadingSpinnerOverlay);
        return _super.apply(this, arguments);
    }
    var _proto = LoadingSpinnerOverlay.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, size = _props.size;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes.overlay,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.center,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    color: "primary",
                    size: size
                })
            })
        });
    };
    return LoadingSpinnerOverlay;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_7__/* .withStyles */ .D)(styles, {
    withTheme: true
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(LoadingSpinnerOverlay));


/***/ }),

/***/ 34614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ updateDataHash; },
/* harmony export */   "u": function() { return /* binding */ hashCode; }
/* harmony export */ });
var hashCode = function(s) {
    var hash = 0;
    if (!(s === null || s === void 0 ? void 0 : s.length)) {
        return String(hash);
    }
    for(var i = 0; i < s.length; i++){
        var char = s.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + char;
        // eslint-disable-next-line no-bitwise
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash);
};
var updateDataHash = function(setDataHash) {
    return function(data) {
        if (data) {
            var hash = hashCode(JSON.stringify(data));
            setDataHash(hash);
        }
    };
};


/***/ }),

/***/ 24877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y6": function() { return /* binding */ toISOString; }
/* harmony export */ });

// NOTE: This preserves the "optionality" of the input fields, e.g. from and to,
// but maps the rhs type to string.
function toISOString(time) {
    var mappedRange = {};
    if (time.from) {
        mappedRange.from = time.from.toISOString();
    }
    if (time.to) {
        mappedRange.to = time.to.toISOString();
    }
    return mappedRange;
}


/***/ }),

/***/ 70912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ oee_kpi_card; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(98230);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(8942);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/svg-gauge@1.0.7/node_modules/svg-gauge/index.js
var svg_gauge = __webpack_require__(39428);
var svg_gauge_default = /*#__PURE__*/__webpack_require__.n(svg_gauge);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
;// CONCATENATED MODULE: ./views/tabs/oee/oee-target-value.tsx


var SVG_NS = "http://www.w3.org/2000/svg";
var OEETargetValue = function(props) {
    var _dialRadius = props.dialRadius, dialRadius = _dialRadius === void 0 ? 40 : _dialRadius, _dialStartAngle = props.dialStartAngle, dialStartAngle = _dialStartAngle === void 0 ? 135 : _dialStartAngle, _dialEndAngle = props.dialEndAngle, dialEndAngle = _dialEndAngle === void 0 ? 45 : _dialEndAngle, _gaugeCenterX = props.gaugeCenterX, gaugeCenterX = _gaugeCenterX === void 0 ? 50 : _gaugeCenterX, _gaugeCenterY = props.gaugeCenterY, gaugeCenterY = _gaugeCenterY === void 0 ? 50 : _gaugeCenterY, targetValue = props.targetValue, gaugeClass = props.gaugeClass;
    var validatedTargetValue = validateTargetValue(targetValue);
    var startValue = validatedTargetValue - 0.5;
    var startAngle = getAngle(startValue, 360 - Math.abs(dialStartAngle - dialEndAngle));
    var endAngle = getAngle(validatedTargetValue, 360 - Math.abs(dialStartAngle - dialEndAngle));
    var coords = getDialCoords(gaugeCenterX, gaugeCenterY, dialRadius, startAngle + dialStartAngle, endAngle + dialStartAngle);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        height: "100%",
        width: "100%",
        xmlns: SVG_NS,
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 100 100",
        className: gaugeClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "#666",
                strokeWidth: 8,
                x1: coords.start.x,
                y1: coords.start.y,
                x2: coords.end.x,
                y2: coords.end.y
            }),
            getSVGText(validatedTargetValue)
        ]
    });
};
/* harmony default export */ var oee_target_value = (OEETargetValue);
var getSVGText = function(targetValue) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("text", {
        fill: "grey",
        textAnchor: "middle",
        fontSize: "40%",
        fontFamily: "sans-serif",
        x: "50",
        y: "63",
        children: [
            "Target: ",
            targetValue.toFixed(1),
            "%"
        ]
    });
};
var validateTargetValue = function(targetValue) {
    return Math.max(Math.min(targetValue, 100), 0);
};
/**
 * Gets cartesian co-ordinates for a specified radius and angle (in degrees)
 * @param cx {Number} The center x co-oriinate
 * @param cy {Number} The center y co-ordinate
 * @param radius {Number} The radius of the circle
 * @param angle {Number} The angle in degrees
 * @return An object with x,y co-ordinates
 */ var getCartesian = function(cx, cy, radius, angle) {
    var rad = angle * Math.PI / 180;
    return {
        x: Math.round((cx + radius * Math.cos(rad)) * 1000) / 1000,
        y: Math.round((cy + radius * Math.sin(rad)) * 1000) / 1000
    };
};
// Returns start and end points for dial
// i.e. starts at 135deg ends at 45deg with large arc flag
// REMEMBER!! angle=0 starts on X axis and then increases clockwise
var getDialCoords = function(cx, cy, radius, startAngle, endAngle) {
    return {
        end: getCartesian(cx, cy, radius, endAngle),
        start: getCartesian(cx, cy, radius, startAngle)
    };
};
/**
 * Translates percentage value to angle. e.g. If gauge span angle is 180deg, then 50%
 * will be 90deg
 */ var getAngle = function(percentage, gaugeSpanAngle) {
    return percentage * gaugeSpanAngle / 100;
};

;// CONCATENATED MODULE: ./views/tabs/oee/oee-kpi-card.tsx
















var styles = function(theme) {
    return {
        card: {
            width: "100%",
            minHeight: "150px"
        },
        cardHover: {
            transition: "box-shadow .25s",
            "&:hover": {
                cursor: "pointer",
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        headingContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "30px"
        },
        title: {
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            position: "absolute"
        },
        valueContainer: {
            display: "flex"
        },
        gaugeWrapper: {
            zIndex: 1,
            display: "flex",
            position: "relative",
            justifyContent: "center",
            alignItems: "center"
        },
        customTargetWrapper: {
            zIndex: 2,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            overflow: "inherit"
        },
        gaugeContainer: {
            width: "100%",
            maxWidth: "300px",
            display: "block"
        },
        gaugeContainerSmall: {
            width: "100%",
            maxWidth: "45px",
            maxHeight: "70px",
            display: "block"
        },
        gaugeValue: {
            strokeWidth: "6"
        },
        gaugeDial: {
            stroke: "#efefef",
            strokeWidth: "6"
        },
        gaugeText: {
            fill: theme.palette.text.primary,
            fontFamily: "sans-serif",
            fontWeight: "bold",
            fontSize: "0.9em"
        },
        gaugeTextSmall: {
            fill: theme.palette.text.primary,
            fontFamily: "sans-serif",
            fontWeight: "bold",
            fontSize: "1.8em"
        }
    };
};
var OEEKPICard = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(OEEKPICard, _Component);
    var _super = (0,_create_super/* default */.Z)(OEEKPICard);
    function OEEKPICard() {
        (0,_class_call_check/* default */.Z)(this, OEEKPICard);
        var _this;
        _this = _super.apply(this, arguments);
        _this.gauge = null;
        _this.gaugeEl = null;
        _this.defaultOptions = {
            animDuration: 1,
            showValue: true,
            max: 100,
            min: 0,
            color: function() {
                return _this.props.gaugeColor;
            },
            gaugeClass: _this.props.classes.gaugeContainer,
            dialClass: _this.props.classes.gaugeDial,
            valueDialClass: _this.props.classes.gaugeValue,
            valueClass: _this.props.classes.gaugeText,
            gaugeTargetValueClass: "gaugeTargetValue",
            label: function(value) {
                if (typeof value !== "number") {
                    return "&infin; %";
                }
                return "".concat(value.toFixed(1), " %");
            }
        };
        return _this;
    }
    var _proto = OEEKPICard.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.renderGauge(this.props);
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, _) {
        var value = this.props.value;
        if (value !== nextProps.value) {
            this.renderGauge(nextProps);
            return true;
        }
        return true;
    };
    _proto.renderGauge = function renderGauge(props) {
        var gaugeOptions = Object.assign({}, this.defaultOptions, props);
        if (props.size === "small") {
            gaugeOptions.valueClass = props.classes.gaugeTextSmall;
            gaugeOptions.label = function(value) {
                if (typeof value !== "number") {
                    return "&infin;";
                }
                return "".concat(value.toFixed(1));
            };
        }
        if (this.gaugeEl) {
            this.gauge = this.gauge || svg_gauge_default()(this.gaugeEl, gaugeOptions);
            this.gauge.setValueAnimated(props.value, gaugeOptions.animDuration);
        }
    };
    _proto.render = function render() {
        var size = this.props.size;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: size === "small" ? 3 : 12,
            sm: 3,
            md: 3,
            lg: 3,
            children: size === "small" ? this.renderOeeSmall() : this.renderOeeWithCard()
        });
    };
    _proto.renderOeeWithCard = function renderOeeWithCard() {
        var _this = this;
        var _props = this.props, classes = _props.classes, title = _props.title, onClick = _props.onClick, targetValue = _props.targetValue, additionalInfo = _props.additionalInfo;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            onClick: onClick ? onClick : undefined,
            className: (0,clsx_m["default"])(classes.card, onClick && classes.cardHover),
            elevation: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        placement: "top",
                        title: additionalInfo !== null && additionalInfo !== void 0 ? additionalInfo : "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.headingContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                align: "center",
                                variant: "body1",
                                className: classes.title,
                                children: title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.gaugeWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.valueContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.gaugeContainer,
                                    ref: function(el) {
                                        return _this.gaugeEl = el;
                                    }
                                })
                            }),
                            targetValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.customTargetWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_target_value, {
                                    targetValue: targetValue
                                })
                            }) : null
                        ]
                    })
                ]
            })
        });
    };
    _proto.renderOeeSmall = function renderOeeSmall() {
        var _this = this;
        var _props = this.props, classes = _props.classes, title = _props.title;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.valueContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.gaugeContainerSmall,
                ref: function(el) {
                    return _this.gaugeEl = el;
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    align: "center",
                    children: title
                })
            })
        });
    };
    return OEEKPICard;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,with_styles/* withStyles */.D)(styles));
/* harmony default export */ var oee_kpi_card = (enhance(OEEKPICard));


/***/ }),

/***/ 74831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NameTooltipProvider */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(48417);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81666);
/* harmony import */ var _devexpress_dx_react_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60975);
/* harmony import */ var _devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70748);
/* harmony import */ var _devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86147);
/* harmony import */ var _mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56646);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16066);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(30985);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(24267);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14724);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(34375);
/* harmony import */ var _mui_material_TableCell__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35153);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8942);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14517);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(25955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99109);
/* harmony import */ var _components_data_type_providers__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(42919);
/* harmony import */ var _hocs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(81861);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5887);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59721);


























var styles = function(theme) {
    return {
        card: {
            display: "block",
            minHeight: "250px"
        },
        cell: {
            cursor: "pointer",
            paddingLeft: theme.spacing(),
            paddingRight: theme.spacing(),
            paddingTop: theme.spacing(-0.5)
        },
        groupButton: {
            verticalAlign: "middle",
            display: "inline-block",
            padding: theme.spacing(),
            marginRight: theme.spacing()
        },
        columnTitle: {
            verticalAlign: "middle"
        },
        customRow: {
            backgroundColor: "#ececec"
        },
        customTotalRow: {
            backgroundColor: "rgb(143, 188, 143)",
            "& > td": {
                fontWeight: 500
            }
        },
        wordSpace: {
            wordSpacing: "0.25em"
        }
    };
};
var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_6__/* .makeStyles */ .ZL)()(styles);
var NameTooltipFormatter = function(param) {
    var value = param.value, row = param.row;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        placement: "top",
        title: row.description,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: value
        })
    });
};
var NameTooltipProvider = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_3__/* .DataTypeProvider */ .zl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        formatterComponent: NameTooltipFormatter
    }, props));
};
var GroupCellWithoutGroupnameBase = function(_param) {
    var colSpan = _param.colSpan, row = _param.row, column = _param.column, expanded = _param.expanded, onToggle = _param.onToggle, classes = _param.classes, children = _param.children, className = _param.className, tableRow = _param.tableRow, tableColumn = _param.tableColumn, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "colSpan",
        "row",
        "column",
        "expanded",
        "onToggle",
        "classes",
        "children",
        "className",
        "tableRow",
        "tableColumn"
    ]);
    var handleClick = function() {
        return onToggle();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_TableCell__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        colSpan: colSpan,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__["default"])(classes.cell, className),
        onClick: handleClick
    }, restProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                className: classes.groupButton,
                size: "large",
                children: expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes.columnTitle,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: children || row.value
                })
            })
        ]
    }));
};
var GroupCellWithoutGroupname = (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_16__/* .withStyles */ .D)(styles, {
    name: "GroupCellWithoutGroupname"
})(GroupCellWithoutGroupnameBase);
var GroupRowWithColSpanBase = function(customClass) {
    return function(_param) {
        var classes = _param.classes, className = _param.className, children = _param.children, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
            "classes",
            "className",
            "children"
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_4__/* .Table.Row */ .cO.Row, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: customClass,
            children: children
        }, restProps));
    };
};
var GroupRowWithColSpan = function(customClass) {
    return (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_16__/* .withStyles */ .D)(styles, {
        name: "GroupRowWithColSpan"
    })(GroupRowWithColSpanBase(customClass));
};
var OEESummaryCalculator = function(t) {
    var totalTime = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, allRows = arguments.length > 2 ? arguments[2] : void 0, classes = arguments.length > 3 ? arguments[3] : void 0, utils = arguments.length > 4 ? arguments[4] : void 0;
    return function(type, rows, getValue) {
        var cdot = " " + String.fromCharCode(183) + " ";
        var rightArrow = " " + String.fromCharCode(8658) + " ";
        if (type === "identifierSumTotal") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classes.wordSpace,
                children: [
                    "TCU =",
                    " ",
                    t([
                        "oee:availability"
                    ], {
                        defaultValue: "Availability"
                    }),
                    cdot,
                    t([
                        "oee:performance"
                    ], {
                        defaultValue: "Performance"
                    }),
                    cdot,
                    t([
                        "oee:quality"
                    ], {
                        defaultValue: "Quality"
                    })
                ]
            });
        } else if (type === "identifierSumGroup") {
            if (!rows.length) {
                return null;
            }
            var summedItems = rows.map(function(row) {
                return "".concat(getValue(row));
            }).join(" + ");
            if (rows[0].datatype === t([
                "oee:availability"
            ], {
                defaultValue: "Availability"
            })) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: classes.wordSpace,
                    children: [
                        "".concat(t([
                            "oee:availability"
                        ], {
                            defaultValue: "Availability"
                        }), " "),
                        " = ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                wordSpacing: "normal"
                            },
                            children: " ".concat(t([
                                "shared:totalTime"
                            ], {
                                defaultValue: "Total Time"
                            }))
                        }),
                        " ",
                        "− ",
                        "(".concat(summedItems, ")")
                    ]
                });
            } else if (rows[0].datatype === t([
                "oee:performance"
            ], {
                defaultValue: "Performance"
            })) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: classes.wordSpace,
                    children: [
                        t([
                            "oee:performance"
                        ], {
                            defaultValue: "Performance"
                        }),
                        " = ",
                        t([
                            "shared:availability"
                        ], {
                            defaultValue: "Availability"
                        }),
                        " −",
                        "(".concat(summedItems, ")")
                    ]
                });
            } else if (rows[0].datatype === t([
                "oee:quality"
            ], {
                defaultValue: "Quality"
            })) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: classes.wordSpace,
                    children: [
                        t([
                            "oee:quality"
                        ], {
                            defaultValue: "Quality"
                        }),
                        " = ",
                        t([
                            "shared:performance"
                        ], {
                            defaultValue: "Performance"
                        }),
                        " −",
                        "(".concat(summedItems, ")")
                    ]
                });
            }
        } else if (type === "durationSumGroup") {
            // return null;
            if (!rows.length) {
                return null;
            }
            var avail = allRows.filter(function(r) {
                return r.datatype === t([
                    "oee:availability"
                ], {
                    defaultValue: "Availability"
                });
            }).reduce(function(acc, row) {
                return acc + row.duration;
            }, 0);
            var perf = allRows.filter(function(r) {
                return r.datatype === t([
                    "oee:performance"
                ], {
                    defaultValue: "Performance"
                });
            }).reduce(function(acc, row) {
                return acc + row.duration;
            }, 0);
            var quality = allRows.filter(function(r) {
                return r.datatype === t([
                    "oee:quality"
                ], {
                    defaultValue: "Quality"
                });
            }).reduce(function(acc, row) {
                return acc + row.duration;
            }, 0);
            if (rows[0].datatype === t([
                "oee:availability"
            ], {
                defaultValue: "Availability"
            })) {
                return utils.formatDistanceStrict(0, (totalTime !== null && totalTime !== void 0 ? totalTime : 0) - avail, {
                    unit: "minute"
                });
            } else if (rows[0].datatype === t([
                "oee:performance"
            ], {
                defaultValue: "Performance"
            })) {
                avail = allRows.filter(function(r) {
                    return r.datatype === t([
                        "oee:availability"
                    ], {
                        defaultValue: "Availability"
                    });
                }).reduce(function(acc, row) {
                    return acc + row.duration;
                }, 0);
                return utils.formatDistanceStrict(0, (totalTime !== null && totalTime !== void 0 ? totalTime : 0) - avail - perf, {
                    unit: "minute"
                });
            } else if (rows[0].datatype === t([
                "oee:quality"
            ], {
                defaultValue: "Quality"
            })) {
                return utils.formatDistanceStrict(0, (totalTime !== null && totalTime !== void 0 ? totalTime : 0) - avail - perf - quality, {
                    unit: "minute"
                });
            }
        } else if (type === "calculation") {
            if (!rows.length || !totalTime) {
                return "=> 0 %";
            }
            var time;
            if (rows[0].datatype === t([
                "oee:availability"
            ], {
                defaultValue: "Availability"
            })) {
                time = totalTime;
            } else if (rows[0].datatype === t([
                "oee:performance"
            ], {
                defaultValue: "Performance"
            })) {
                var avail1 = allRows.filter(function(r) {
                    return r.datatype === t([
                        "oee:availability"
                    ], {
                        defaultValue: "Availability"
                    });
                }).reduce(function(acc, row) {
                    return acc + row.duration;
                }, 0);
                time = totalTime - avail1;
            } else if (rows[0].datatype === t([
                "oee:quality"
            ], {
                defaultValue: "Quality"
            })) {
                var avail2 = allRows.filter(function(r) {
                    return r.datatype === t([
                        "oee:availability"
                    ], {
                        defaultValue: "Availability"
                    });
                }).reduce(function(acc, row) {
                    return acc + row.duration;
                }, 0);
                var perf1 = allRows.filter(function(r) {
                    return r.datatype === t([
                        "oee:performance"
                    ], {
                        defaultValue: "Performance"
                    });
                }).reduce(function(acc, row) {
                    return acc + row.duration;
                }, 0);
                time = totalTime - avail2 - perf1;
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes.wordSpace,
                children: "".concat(rightArrow, " ").concat((!time ? 0 : (time - rows.reduce(function(acc, row) {
                    return acc + row.duration;
                }, 0)) / time * 100).toFixed(2), "%")
            });
        } else if (type === "calculationTotal" || type === "durationTotal") {
            if (!rows.length || !totalTime) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: rightArrow
                });
            }
            var calcs = {
                Availability: 0,
                Performance: 0,
                Quality: 0
            };
            rows.map(function(row) {
                calcs[row.datatype] += row.duration;
            });
            calcs.Availability = totalTime - calcs.Availability;
            calcs.Performance = calcs.Availability - calcs.Performance;
            calcs.Quality = calcs.Performance - calcs.Quality;
            if (type === "durationTotal") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: classes.wordSpace,
                    children: [
                        "".concat((calcs.Availability / totalTime * 100).toFixed(2), "%"),
                        " \xb7",
                        " ",
                        "".concat((calcs.Availability === 0 ? 0 : calcs.Performance / calcs.Availability * 100).toFixed(2), "%"),
                        " \xb7",
                        " ",
                        "".concat((calcs.Performance === 0 ? 0 : calcs.Quality / calcs.Performance * 100).toFixed(2), "%")
                    ]
                });
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes.wordSpace,
                children: "= ".concat((calcs.Availability === 0 || calcs.Performance === 0 ? 0 : calcs.Availability / totalTime * (calcs.Performance / calcs.Availability) * (calcs.Quality / calcs.Performance) * 100).toFixed(2), "%")
            });
        }
        return _devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_3__/* .IntegratedSummary.defaultCalculator */ .Y5.defaultCalculator(type, rows, getValue);
    };
};
var reshapeData = function(param) {
    var t = param.t, data = param.data;
    var reshapeStop = function(stop) {
        return {
            type: stop.type || generated_graphql_schema__WEBPACK_IMPORTED_MODULE_17__/* .StopType.DOWNTIME */ .xn.DOWNTIME,
            name: stop.type ? stop.stopCauseName : stop.isMicroStop ? t([
                "shared:microStop"
            ], {
                defaultValue: "Micro stops"
            }) : t([
                "shared:unregisteredStops"
            ], {
                defaultValue: "Unregistered stops"
            }),
            description: stop.type ? stop.stopCauseDescription : stop.isMicroStop ? t([
                "oee:timeLostDueToMicroStops"
            ], {
                defaultValue: "Time lost due to micro stops"
            }) : t([
                "oee:timeLostDueToUnregisteredStops"
            ], {
                defaultValue: "Time lost due to unregistered stops"
            }),
            duration: stop.accDuration,
            OEEPercentage: ""
        };
    };
    var ref;
    var ref1 = (ref = data === null || data === void 0 ? void 0 : data.oee) !== null && ref !== void 0 ? ref : {
        scrapLoss: 0,
        speedLoss: 0
    }, scrapLoss = ref1.scrapLoss, speedLoss = ref1.speedLoss;
    var stopStats = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((data === null || data === void 0 ? void 0 : data.stopStats) || []).sort(function(a, b) {
        return b.accDuration - a.accDuration;
    });
    var avaliability = stopStats.filter(function(s) {
        return s.type === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_17__/* .StopType.NO_ACT */ .xn.NO_ACT || s.type === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_17__/* .StopType.NON_PROD */ .xn.NON_PROD || s.type === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_17__/* .StopType.BATCH_NON_PROD */ .xn.BATCH_NON_PROD;
    });
    var downtimeStops = stopStats.filter(function(s) {
        return s.type === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_17__/* .StopType.DOWNTIME */ .xn.DOWNTIME;
    });
    var unregisteredStops = stopStats.filter(function(s) {
        return !s.type && !s.isMicroStop;
    });
    var microStops = stopStats.filter(function(s) {
        return !s.type && s.isMicroStop;
    });
    var returnData = [];
    var cnt = 1;
    if (avaliability === null || avaliability === void 0 ? void 0 : avaliability.length) {
        avaliability.forEach(function(s) {
            return returnData.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, reshapeStop(s)), {
                identifier: "A".concat(cnt++),
                datatype: t([
                    "oee:availability"
                ], {
                    defaultValue: "Availability"
                })
            }));
        });
    } else {
        returnData.push({
            identifier: "A".concat(cnt++),
            datatype: t([
                "oee:availability"
            ], {
                defaultValue: "Availability"
            }),
            type: "NON_PROD",
            name: t([
                "oee:availabilityLoss"
            ], {
                defaultValue: "Availability loss"
            }),
            description: t([
                "oee:timeLostDueToAvailablity"
            ], {
                defaultValue: "Time lost due to availablity"
            }),
            duration: 0,
            OEEPercentage: ""
        });
    }
    cnt = 1;
    returnData.push({
        identifier: "P".concat(cnt++),
        datatype: t([
            "oee:performance"
        ], {
            defaultValue: "Performance"
        }),
        type: "DOWNTIME",
        name: t([
            "oee:speedLoss"
        ], {
            defaultValue: "Speed loss"
        }),
        description: t([
            "oee:timeLostDueToSpeed"
        ], {
            defaultValue: "Time lost due to running at lower than validated speed"
        }),
        duration: speedLoss,
        OEEPercentage: ""
    });
    if (unregisteredStops && unregisteredStops.length) {
        returnData.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, reshapeStop(unregisteredStops.reduce(function(acc, stat) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, acc), {
                accDuration: acc.accDuration + stat.accDuration,
                numberOfStops: acc.numberOfStops + stat.numberOfStops
            });
        }, {
            accDuration: 0,
            accTarget: 0,
            isMicroStop: true,
            stopCategoryName: "Unregistered stop",
            stopCauseName: "Unregistered stop",
            stopCauseDescription: "",
            stopCauseId: "UNREGISTERED_STOP",
            numberOfStops: 0
        }))), {
            identifier: "P".concat(cnt++),
            datatype: t([
                "oee:performance"
            ], {
                defaultValue: "Performance"
            })
        }));
    }
    if (microStops && microStops.length) {
        returnData.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, reshapeStop(microStops.reduce(function(acc, stat) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, acc), {
                accDuration: acc.accDuration + stat.accDuration,
                numberOfStops: acc.numberOfStops + stat.numberOfStops
            });
        }, {
            accDuration: 0,
            accTarget: 0,
            isMicroStop: true,
            stopCategoryName: "Micro stop",
            stopCauseName: "Micro stop",
            stopCauseDescription: "",
            stopCauseId: "MICRO_STOP",
            numberOfStops: 0
        }))), {
            identifier: "P".concat(cnt++),
            datatype: t([
                "oee:performance"
            ], {
                defaultValue: "Performance"
            })
        }));
    }
    downtimeStops === null || downtimeStops === void 0 ? void 0 : downtimeStops.forEach(function(s) {
        return returnData.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, reshapeStop(s)), {
            identifier: "P".concat(cnt++),
            datatype: t([
                "oee:performance"
            ], {
                defaultValue: "Performance"
            })
        }));
    });
    cnt = 1;
    returnData.push({
        identifier: "Q".concat(cnt++),
        datatype: t([
            "oee:quality"
        ], {
            defaultValue: "Quality"
        }),
        type: "DOWNTIME",
        name: t([
            "shared:scrap"
        ], {
            defaultValue: "Scrap"
        }),
        description: t([
            "oee:timeLostDueToScrap"
        ], {
            defaultValue: "Time lost due to scrapped items"
        }),
        duration: scrapLoss,
        OEEPercentage: ""
    });
    return returnData;
};
var messages = {
    sum: "OEE<sub>1</sub>"
};
var Constants = {
    grouping: [
        {
            columnName: "datatype"
        }
    ],
    tableColumnExtensions: [
        {
            columnName: "duration",
            align: "right"
        }
    ],
    totalSummaryItems: [
        {
            columnName: "identifier",
            type: "identifierSumTotal"
        },
        {
            columnName: "duration",
            type: "durationTotal"
        },
        {
            columnName: "OEEPercentage",
            type: "calculationTotal"
        }, 
    ],
    groupSummaryItems: [
        {
            columnName: "identifier",
            type: "identifierSumGroup"
        },
        {
            columnName: "duration",
            type: "durationSumGroup"
        },
        {
            columnName: "OEEPercentage",
            type: "calculation"
        }, 
    ],
    stopCauseTypeColumns: [
        "identifier"
    ],
    durationTypeColumns: [
        "duration"
    ],
    nameColumns: [
        "name"
    ]
};
var OEETableCard = function(param) {
    var data = param.data;
    var ref;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_20__/* .useTranslation */ .$)([
        "shared",
        "device",
        "oee"
    ]), 1), t = ref1[0];
    var ref2 = useStyles(), classes = ref2.classes, theme = ref2.theme;
    var utils = (0,_hocs__WEBPACK_IMPORTED_MODULE_21__/* .useUtils */ .n)();
    var totalTime = data === null || data === void 0 ? void 0 : (ref = data.oee) === null || ref === void 0 ? void 0 : ref.totalEquipmentTime;
    var rows = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return reshapeData({
            data: data,
            t: t
        });
    }, [
        t,
        data
    ]);
    var columns = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return [
            {
                name: "datatype",
                title: t([
                    "oee:oeeGroup"
                ], {
                    defaultValue: "OEE Group"
                })
            },
            {
                name: "identifier",
                title: t([
                    "oee:variable"
                ], {
                    defaultValue: "Variable"
                })
            },
            {
                name: "name",
                title: t([
                    "shared:name"
                ], {
                    defaultValue: "Name"
                })
            },
            {
                name: "duration",
                title: t([
                    "shared:duration"
                ], {
                    defaultValue: "Duration"
                })
            },
            {
                name: "OEEPercentage",
                title: t([
                    "oee:oeePercentage"
                ], {
                    defaultValue: "OEE Percentage"
                })
            }, 
        ];
    }, [
        t
    ]);
    var onPredicate = function(params) {
        var tableRow = params.tableRow, tableColumn = params.tableColumn;
        return (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .isGroupSummaryTableCell */ .Zt5)(tableRow, tableColumn) || (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .isTotalSummaryTableCell */ .Vfj)(tableRow, tableColumn);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
            elevation: 1,
            className: classes.card,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_4__/* .Grid */ .rj, {
                    rows: rows,
                    columns: columns,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_data_type_providers__WEBPACK_IMPORTED_MODULE_25__/* .StopsCauseTypeProvider */ .Wi, {
                            for: Constants.stopCauseTypeColumns,
                            theme: theme,
                            t: t
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NameTooltipProvider, {
                            for: Constants.nameColumns,
                            theme: theme
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_data_type_providers__WEBPACK_IMPORTED_MODULE_25__/* .DurationTypeProvider */ .mL, {
                            for: Constants.durationTypeColumns,
                            utils: utils,
                            t: t,
                            warnWhenNegative: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_3__/* .GroupingState */ .oA, {
                            grouping: Constants.grouping,
                            defaultExpandedGroups: [
                                t([
                                    "oee:availability"
                                ], {
                                    defaultValue: "Availability"
                                }),
                                t([
                                    "oee:performance"
                                ], {
                                    defaultValue: "Performance"
                                }),
                                t([
                                    "oee:quality"
                                ], {
                                    defaultValue: "Quality"
                                }), 
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_3__/* .SummaryState */ .RX, {
                            totalItems: Constants.totalSummaryItems,
                            groupItems: Constants.groupSummaryItems
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_3__/* .IntegratedGrouping */ .oR, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_3__/* .IntegratedSummary */ .Y5, {
                            calculator: OEESummaryCalculator(t, totalTime, rows, classes, utils)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_4__/* .Table */ .cO, {
                            columnExtensions: Constants.tableColumnExtensions
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_4__/* .TableHeaderRow */ .KA, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_4__/* .TableGroupRow */ .x6, {
                            cellComponent: GroupCellWithoutGroupname
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_4__/* .TableSummaryRow */ .RA, {
                            groupRowComponent: GroupRowWithColSpan(classes.customRow),
                            totalRowComponent: GroupRowWithColSpan(classes.customTotalRow),
                            messages: messages
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_core__WEBPACK_IMPORTED_MODULE_2__/* .Template */ .YS, {
                            name: "tableCell",
                            predicate: onPredicate,
                            children: function(params) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_core__WEBPACK_IMPORTED_MODULE_2__/* .TemplateConnector */ .eT, {
                                    children: function(getters) {
                                        var tableRow = params.tableRow, tableColumn = params.tableColumn, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(params, [
                                            "tableRow",
                                            "tableColumn"
                                        ]);
                                        var columnSummaries = [];
                                        if (getters === null || getters === void 0 ? void 0 : getters.groupSummaryValues) {
                                            if ((0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .isGroupSummaryTableCell */ .Zt5)(tableRow, tableColumn)) {
                                                var ref;
                                                columnSummaries = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .getColumnSummaries */ .EOv)(getters.groupSummaryItems.map(function(item) {
                                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, item), {
                                                        type: Symbol(item.type)
                                                    });
                                                }), ((ref = tableColumn.column) === null || ref === void 0 ? void 0 : ref.name) || "", getters.groupSummaryValues[String(tableRow.row.compoundKey)]);
                                            } else {
                                                var ref1;
                                                columnSummaries = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .getColumnSummaries */ .EOv)(getters.totalSummaryItems.map(function(item) {
                                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, item), {
                                                        type: Symbol(item.type)
                                                    });
                                                }), ((ref1 = tableColumn.column) === null || ref1 === void 0 ? void 0 : ref1.name) || "", getters.totalSummaryValues);
                                            }
                                        }
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TableCell__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                                            style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, tableColumn.style), {
                                                textAlign: tableColumn.align,
                                                paddingLeft: "8px",
                                                paddingRight: "8px",
                                                color: theme.palette.text.primary,
                                                fontWeight: 400,
                                                borderBottom: "1px solid rgba(224, 224, 224, 1)",
                                                textOverflow: "wrap"
                                            }),
                                            children: columnSummaries.map(function(summary) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
                                                    children: summary.value
                                                }, String(summary.value));
                                            })
                                        }));
                                    }
                                });
                            }
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OEETableCard);


/***/ }),

/***/ 26946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ oee_waterfall_card; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Warning.js
var Warning = __webpack_require__(35514);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(44143);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/router.js
var next_router = __webpack_require__(13515);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ./components/bars/wide-snackbar.tsx
var wide_snackbar = __webpack_require__(15169);
// EXTERNAL MODULE: ./components/containers/highcharts.tsx
var highcharts = __webpack_require__(75805);
// EXTERNAL MODULE: ./hooks/use-translation.tsx
var use_translation = __webpack_require__(59721);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/green.js
var green = __webpack_require__(21955);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/red.js
var red = __webpack_require__(16438);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/blue.js
var blue = __webpack_require__(35799);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(25955);
;// CONCATENATED MODULE: ./lib/highcharts/oee-waterfall-config.ts







var getDuration = function(ms) {
    var roundUpToNearestMinute = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // TODO: Rewrite this to use DateFNS for simplicity?
    var absMs = Math.abs(ms);
    var add = 0;
    var seconds = Math.floor(absMs / 1..seconds % 60);
    if (roundUpToNearestMinute && seconds >= 1) {
        add = 60000;
        seconds = 0;
    } else if (roundUpToNearestMinute) {
        seconds = 0;
    }
    var minutes = Math.floor((absMs + add) / 1..minutes % 60);
    var hours = Math.floor((absMs + add) / 1..hours);
    var zeroHours = hours < 10 ? "0".concat(hours) : hours;
    var zeroMinutes = minutes < 10 ? "0".concat(minutes) : minutes;
    var zeroSeconds = seconds < 10 ? "0".concat(seconds) : seconds;
    var result = {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        human: "".concat(ms >= 0 ? "" : "-", "\n                      ").concat(zeroHours, ":").concat(zeroMinutes).concat(roundUpToNearestMinute ? "" : ":".concat(zeroSeconds))
    };
    return result;
};
var getDurationPercentage = function(ms, totalEquipmentTime) {
    var result = ms / totalEquipmentTime * 100;
    return result;
};
var getSeriesData = function(t, oee, stopCauseStats, theme, displayDeviations) {
    var seriesData = [];
    if (!oee || !stopCauseStats) {
        return seriesData;
    }
    var aggregatedDeviationTranslation = t([
        "oee:targetsDeviation"
    ], {
        defaultValue: "Targets deviation"
    });
    seriesData.push({
        name: t([
            "oee:totalEquipmentTime"
        ], {
            defaultValue: "Total Equipment Time"
        }),
        y: oee.totalEquipmentTime / 1..hours
    });
    var sortedStopStats = (0,_to_consumable_array/* default */.Z)(stopCauseStats).sort(function(a, b) {
        return b.accDuration - a.accDuration;
    });
    var noActivityStops = sortedStopStats.filter(function(s) {
        return s.type === schema/* StopType.NO_ACT */.xn.NO_ACT;
    });
    var nonProdStops = sortedStopStats.filter(function(s) {
        return s.type === schema/* StopType.NON_PROD */.xn.NON_PROD;
    });
    var batchNonProdStops = sortedStopStats.filter(function(s) {
        return s.type === schema/* StopType.BATCH_NON_PROD */.xn.BATCH_NON_PROD;
    });
    var unregisteredStops = sortedStopStats.filter(function(s) {
        return !s.type && !s.isMicroStop;
    });
    var microStops = sortedStopStats.filter(function(s) {
        return !s.type && s.isMicroStop;
    });
    var downtimeStops = Array.from(sortedStopStats.filter(function(s) {
        return s.type === schema/* StopType.DOWNTIME */.xn.DOWNTIME;
    }).reduce(function(aggregateDowntimeStops, stop) {
        var stopCauseName = stop.stopCauseName.trim();
        var s = aggregateDowntimeStops.get(stopCauseName);
        if (!s) {
            aggregateDowntimeStops.set(stopCauseName, (0,_object_spread/* default */.Z)({}, stop));
        } else {
            s.accDuration += stop.accDuration;
        }
        return aggregateDowntimeStops;
    }, new Map()).values());
    {
        var aggregateDeviations = displayDeviations && noActivityStops.some(function(stop) {
            return stop.accTarget;
        });
        if (aggregateDeviations) {
            var totalDeviation = noActivityStops.filter(function(stop) {
                return stop.accTarget;
            }).reduce(function(acc, stop) {
                return acc + (stop.accTarget - stop.accDuration);
            }, 0) / 1..hours;
            var color = 0 < totalDeviation ? green/* default.200 */.Z[200] : red/* default.200 */.Z[200];
            seriesData.push({
                name: aggregatedDeviationTranslation,
                color: color,
                y: totalDeviation
            });
        }
        noActivityStops.forEach(function(s) {
            seriesData.push({
                name: s.stopCauseName,
                color: theme.blackbird.stops[s.type].color.normal,
                y: -(aggregateDeviations && s.accTarget || s.accDuration) / 1..hours,
                type: s.type,
                stopCategory: s.stopCategoryName
            });
        });
    }
    seriesData.push({
        name: t([
            "oee:mannedTime"
        ], {
            defaultValue: "Manned Time"
        }),
        isSum: true
    });
    {
        var aggregateDeviations1 = displayDeviations && nonProdStops.some(function(stop) {
            return stop.accTarget;
        });
        if (aggregateDeviations1) {
            var totalDeviation1 = nonProdStops.filter(function(stop) {
                return stop.accTarget;
            }).reduce(function(acc, stop) {
                return acc + (stop.accTarget - stop.accDuration);
            }, 0) / 1..hours;
            var color1 = 0 < totalDeviation1 ? green/* default.200 */.Z[200] : red/* default.200 */.Z[200];
            seriesData.push({
                name: aggregatedDeviationTranslation,
                color: color1,
                y: totalDeviation1
            });
        }
        nonProdStops.forEach(function(s) {
            seriesData.push({
                name: s.stopCauseName,
                color: theme.blackbird.stops[s.type].color.normal,
                y: -(aggregateDeviations1 && s.accTarget || s.accDuration) / 1..hours,
                type: s.type,
                stopCategory: s.stopCategoryName
            });
        });
    }
    seriesData.push({
        name: t([
            "oee:productionTime"
        ], {
            defaultValue: "Production Time"
        }),
        isSum: true
    });
    {
        var aggregateDeviations2 = displayDeviations && batchNonProdStops.some(function(stop) {
            return stop.accTarget;
        });
        if (aggregateDeviations2) {
            var totalDeviation2 = batchNonProdStops.filter(function(stop) {
                return stop.accTarget;
            }).reduce(function(acc, stop) {
                return acc + (stop.accTarget - stop.accDuration);
            }, 0) / 1..hours;
            var color2 = 0 < totalDeviation2 ? green/* default.200 */.Z[200] : red/* default.200 */.Z[200];
            seriesData.push({
                name: aggregatedDeviationTranslation,
                color: color2,
                y: totalDeviation2
            });
        }
        batchNonProdStops.forEach(function(s) {
            seriesData.push({
                name: s.stopCauseName,
                color: theme.blackbird.stops[s.type].color.normal,
                y: -(aggregateDeviations2 && s.accTarget || s.accDuration) / 1..hours,
                type: s.type,
                stopCategory: s.stopCategoryName
            });
        });
    }
    seriesData.push({
        name: t([
            "oee:operatingTime"
        ], {
            defaultValue: "Operating Time"
        }),
        isSum: true
    });
    if (oee === null || oee === void 0 ? void 0 : oee.speedLoss) {
        seriesData.push({
            name: t([
                "oee:speedLoss"
            ], {
                defaultValue: "Speed loss"
            }),
            color: theme.blackbird.stops.MICRO_STOP.color.normal,
            y: -(oee.speedLoss / 1..hours)
        });
    }
    if (oee === null || oee === void 0 ? void 0 : oee.scrapLoss) {
        seriesData.push({
            name: t([
                "oee:scrapLoss"
            ], {
                defaultValue: "Scrap loss"
            }),
            color: theme.blackbird.stops.MICRO_STOP.color.normal,
            y: -(oee.scrapLoss / 1..hours)
        });
    }
    if (unregisteredStops.length) {
        var totalMs = unregisteredStops.reduce(function(acc, stat) {
            return acc + stat.accDuration;
        }, 0);
        seriesData.push({
            name: t([
                "shared:unregisteredStops"
            ], {
                defaultValue: "Unregistered stops"
            }),
            color: theme.blackbird.stops.UNREGISTERED.color.normal,
            y: -(totalMs / 1..hours),
            type: "UNREGISTERED"
        });
    }
    if (microStops.length) {
        var totalMs1 = microStops.reduce(function(acc, stat) {
            return acc + stat.accDuration;
        }, 0);
        seriesData.push({
            name: t([
                "shared:microStops"
            ], {
                defaultValue: "Micro stops"
            }),
            color: theme.blackbird.stops.MICRO_STOP.color.normal,
            y: -(totalMs1 / 1..hours),
            type: "MICRO_STOP"
        });
    }
    {
        var aggregateDeviations3 = displayDeviations && downtimeStops.some(function(stop) {
            return stop.accTarget;
        });
        if (aggregateDeviations3) {
            var totalDeviation3 = downtimeStops.filter(function(stop) {
                return stop.accTarget;
            }).reduce(function(acc, stop) {
                return acc + (stop.accTarget - stop.accDuration);
            }, 0) / 1..hours;
            var color3 = 0 < totalDeviation3 ? green/* default.200 */.Z[200] : red/* default.200 */.Z[200];
            seriesData.push({
                name: aggregatedDeviationTranslation,
                color: color3,
                y: totalDeviation3
            });
        }
        downtimeStops.forEach(function(s) {
            seriesData.push({
                name: s.stopCauseName,
                color: theme.blackbird.stops[s.type].color.normal,
                y: -(aggregateDeviations3 && s.accTarget || s.accDuration) / 1..hours,
                type: s.type,
                stopCategory: s.stopCategoryName
            });
        });
    }
    seriesData.push({
        name: t([
            "oee:valuedOperatingTime"
        ], {
            defaultValue: "Valued Operating Time"
        }),
        isSum: true,
        color: "rgba(0,153,76,0.5)"
    });
    // Handle multiple stopCauses with the same name in different categories, by
    // appending spaces behind the name, to get individual bars in waterfall.
    return seriesData.reduce(function(acc, cur) {
        var name = cur.name;
        while(acc.find(function(s) {
            return s.name === name;
        })){
            name = "".concat(name, " ");
        }
        acc.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur), {
            name: name
        }));
        return acc;
    }, []);
};
var getPlotbands = function(stopStats, oee, theme, displayDeviations) {
    var setAlphaOfColor = function(rgbColor, alpha) {
        return rgbColor.replace(/[\d\.]+\)$/g, "".concat(alpha, ")")); // eslint-disable-line no-useless-escape
    };
    var noActStops = stopStats.filter(function(s) {
        return s.type === schema/* StopType.NO_ACT */.xn.NO_ACT;
    });
    var nonProdStops = stopStats.filter(function(s) {
        return s.type === schema/* StopType.NON_PROD */.xn.NON_PROD;
    });
    var batchNonProdStops = stopStats.filter(function(s) {
        return s.type === schema/* StopType.BATCH_NON_PROD */.xn.BATCH_NON_PROD;
    });
    var downtimeStops = stopStats.filter(function(s) {
        return s.type === schema/* StopType.DOWNTIME */.xn.DOWNTIME;
    }).map(function(param) {
        var accDuration = param.accDuration;
        return {
            accDuration: accDuration
        };
    });
    var unregisteredStops = stopStats.filter(function(s) {
        return !s.type && !s.isMicroStop;
    });
    var microStops = stopStats.filter(function(s) {
        return !s.type && s.isMicroStop;
    });
    if (microStops.length) {
        downtimeStops.push({
            accDuration: microStops.reduce(function(acc, curr) {
                return acc + curr.accDuration;
            }, 0)
        });
    }
    if (unregisteredStops.length) {
        downtimeStops.push({
            accDuration: unregisteredStops.reduce(function(acc, curr) {
                return acc + curr.accDuration;
            }, 0)
        });
    }
    if (oee && oee.speedLoss) {
        downtimeStops.push({
            accDuration: oee.speedLoss
        });
    }
    if (oee && oee.scrapLoss) {
        downtimeStops.push({
            accDuration: oee.scrapLoss
        });
    }
    var typeStopsPairs = [
        [
            schema/* StopType.NO_ACT */.xn.NO_ACT,
            noActStops
        ],
        [
            schema/* StopType.NON_PROD */.xn.NON_PROD,
            nonProdStops
        ],
        [
            schema/* StopType.BATCH_NON_PROD */.xn.BATCH_NON_PROD,
            batchNonProdStops
        ],
        [
            schema/* StopType.DOWNTIME */.xn.DOWNTIME,
            downtimeStops
        ], 
    ];
    var ref = (0,_sliced_to_array/* default */.Z)(typeStopsPairs.reduce(function(param, param1, i) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), offset = _param[0], bands = _param[1], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 2), type = _param1[0], stops = _param1[1];
        var extraColumn = +(displayDeviations && stops.some(function(stop) {
            return !!stop.accTarget;
        }));
        var width = stops.length + extraColumn;
        bands.push({
            color: setAlphaOfColor(stops.length ? theme.blackbird.stops[type].color.normal : "white", stops.length ? 0.7 : 0),
            from: offset,
            to: width + offset,
            label: {
                // @ts-ignore
                text: "".concat((stops.reduce(function(acc, cur) {
                    return acc + cur.accDuration;
                }, 0) / 1..hours).toFixed(0), "h"),
                style: {
                    color: "black",
                    fontWeight: "bold"
                }
            }
        });
        return [
            offset + width + 1,
            bands
        ];
    }, [
        0.5,
        []
    ]), 2), plotBands = ref[1];
    return plotBands;
};
var getConfig = function(param) {
    var height = param.height, stopStats = param.stopStats, oee = param.oee, theme = param.theme, t = param.t, router = param.router, displayDeviations = param.displayDeviations, toggleDisplayDeviations = param.toggleDisplayDeviations;
    var anyTargets = stopStats.some(function(stop) {
        return !!stop.accTarget;
    });
    return {
        chart: {
            type: "waterfall",
            zoomType: "x",
            height: height,
            animation: {
                duration: 1000
            }
        },
        exporting: {
            enabled: true,
            filename: "oee-chart",
            sourceWidth: 2048,
            sourceHeight: 512,
            scale: 1,
            chartOptions: {
                title: false
            },
            menuItemDefinitions: {
                printChart: {
                    text: t([
                        "shared:printChart"
                    ], {
                        defaultValue: "Print chart"
                    })
                },
                downloadPNG: {
                    text: t([
                        "shared:downloadPNG"
                    ], {
                        defaultValue: "Download PNG image"
                    })
                },
                downloadJPEG: {
                    text: t([
                        "shared:downloadJPEG"
                    ], {
                        defaultValue: "Download JPEG image"
                    })
                },
                downloadPDF: {
                    text: t([
                        "shared:downloadPDF"
                    ], {
                        defaultValue: "Download PDF image"
                    })
                },
                downloadSVG: {
                    text: t([
                        "shared:downloadSVG"
                    ], {
                        defaultValue: "Download SVG image"
                    })
                }
            },
            buttons: {
                contextButton: {
                    y: 0,
                    x: 0,
                    menuItems: [
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downdloadSVG"
                    ]
                }
            }
        },
        title: false,
        xAxis: {
            type: "category",
            plotBands: getPlotbands(stopStats, oee, theme, displayDeviations)
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    verticalAlign: "top",
                    x: 0,
                    y: -25,
                    style: {
                        color: "black"
                    }
                },
                point: {
                    events: {
                        mouseOver: function mouseOver(e) {
                            var ref;
                            if ((ref = e.target) === null || ref === void 0 ? void 0 : ref.type) {
                                e.target.graphic.element.style.cursor = "pointer";
                            }
                        }
                    }
                }
            }
        },
        yAxis: {
            title: {
                text: t([
                    "shared:hours"
                ], {
                    defaultValue: "Hours"
                })
            },
            labels: {
                overflow: "justify"
            }
        },
        legend: {
            enabled: anyTargets
        },
        tooltip: {
            pointFormat: "<b>{point.y:,.1f}</b> ".concat(t([
                "shared:hours"
            ], {
                defaultValue: "Hours"
            }))
        },
        credits: {
            enabled: false
        },
        series: [
            {
                showInLegend: false,
                upColor: "rgba(70,130,180,0.7)",
                tooltip: {
                    pointFormatter: function pointFormatter() {
                        var htmlString = "<b>".concat(this.name, ":</b> ").concat(this.y < 0 ? "-" : "").concat(getDuration(Math.abs(this.y * 1..hours)).human, "<br/>\n              <b>Percent : </b> ").concat(getDurationPercentage(Math.abs(this.y * 1..hours), oee.totalEquipmentTime).toFixed(1), " %");
                        if (this.stopCategory) {
                            return "<b>".concat(this.stopCategory, "</b><br/>").concat(htmlString);
                        } else {
                            return htmlString;
                        }
                    }
                },
                minPointLength: 5,
                borderColor: "rgba(0,0,0,0)",
                lineColor: "#ccc",
                data: getSeriesData(t, oee, stopStats, theme, displayDeviations),
                dataLabels: {
                    enabled: true,
                    defer: false,
                    formatter: function formatter() {
                        if (Math.abs(this.y) > 10) {
                            return "".concat(this.y.toFixed(0), "h");
                        } else {
                            return "".concat(this.y.toFixed(1), "h");
                        }
                    },
                    style: {
                        fontWeight: "bold"
                    }
                },
                pointPadding: 0,
                events: {
                    click: function click(e) {
                        if (e.point.type && e.point.name) {
                            var pathname = router.pathname, query = router.query;
                            router_default().push({
                                pathname: pathname,
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                    tab: "analytics",
                                    name: e.point.name,
                                    type: e.point.type
                                })
                            });
                        }
                    }
                }
            },
            {
                showInLegend: true,
                visible: displayDeviations && anyTargets,
                color: blue/* default.200 */.Z[200],
                name: t([
                    "oee:aggregateTargetDeviations"
                ], {
                    defaultValue: "Aggregate target deviations"
                }),
                events: {
                    legendItemClick: function legendItemClick(e) {
                        e.preventDefault();
                        toggleDisplayDeviations();
                    }
                }
            }, 
        ]
    };
};
/* harmony default export */ var oee_waterfall_config = (getConfig);

;// CONCATENATED MODULE: ./views/tabs/oee/oee-waterfall-card.tsx














var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        actions: {
            paddingLeft: theme.spacing(),
            paddingBottom: theme.spacing()
        },
        contentHeader: {
            "& > div": {
                maxWidth: "100%"
            }
        },
        message: {
            display: "flex",
            alignItems: "center"
        },
        icon: {
            float: "left",
            fontSize: 20,
            opacity: 0.9,
            marginRight: theme.spacing()
        }
    };
});
var OEEWaterfallCard = function(param) {
    var data = param.data, refetch = param.refetch, loading = param.loading, dataHash = param.dataHash;
    var ref = (0,react.useState)(false), displayDeviations = ref[0], setDisplayDeviations = ref[1];
    var classes = useStyles().classes;
    var theme = (0,useTheme/* default */.Z)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)([
        "shared",
        "oee"
    ]), 1), t = ref1[0];
    var router = (0,next_router.useRouter)();
    var toggleDisplayDeviations = (0,react.useCallback)(function() {
        setDisplayDeviations(!displayDeviations);
    }, [
        displayDeviations
    ]);
    var positiveSpeedLossWarning;
    // NOTE: All durations are positive numbers, but are reverted in the waterfall when displayed. This is why we
    // need to check for the speedloss being < 0, to indicate it being wrong.
    if (data && data.oee && data.oee.speedLoss < 0) {
        positiveSpeedLossWarning = /*#__PURE__*/ (0,jsx_runtime.jsx)(wide_snackbar/* default */.Z, {
            message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                        className: classes.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classes.message,
                        children: t([
                            "oee:speedlossWarning"
                        ], {
                            defaultValue: "Positive speedloss is a result of setting the validated line speed lower than the actual max line speed. We suggest to change the validated line speed to the max line speed"
                        })
                    })
                ]
            })
        });
    }
    if (!data) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            elevation: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                children: [
                    positiveSpeedLossWarning || null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(highcharts/* Graph */.k, {
                        compareForUpdate: [
                            dataHash,
                            displayDeviations
                        ].join("-"),
                        aggressivelyMinimizeRendering: true,
                        configOptions: {
                            height: "350px",
                            refetch: refetch,
                            timeRange: data.timeRange,
                            stopStats: data.stopStats,
                            oee: data.oee,
                            theme: theme,
                            t: t,
                            router: router,
                            displayDeviations: displayDeviations,
                            toggleDisplayDeviations: toggleDisplayDeviations
                        },
                        configFn: oee_waterfall_config,
                        loading: loading
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var oee_waterfall_card = (OEEWaterfallCard);


/***/ })

}]);